exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-booking-cms {\n  cursor: pointer;\n  margin: 10px 1% 0 1%;\n}\n.btn-booking-cms.make-hover {\n  transition: all 0.4s ease-in-out;\n}\n.btn-booking-cms.make-hover:hover {\n  background-color: var(--btn-color) !important;\n  color: var(--btn-background-color) !important;\n  border-color: var(--btn-color) !important;\n}", ""]);

// exports
